


// import HeroHome from "../../LandComponents/HeroHome/HeroHome";
// import HeroSection from "../../LandComponents/HeroSection/HeroSection";
// import NavHome from "../../LandComponents/NavHome/NavHome";
import img1  from "../../../Images/Landing.jpg"
import "./OurWork.css"

function OurWork(){  
    return <>

          <div className="OurWorkCover">

                <div className="OurWorkContent">

                        <div className="OurWorkImage">

                            <img src={img1} />

                        </div>
                        <div className="OurWorkWording">
                            <h3>WHAT WE DO</h3>
                            <h1>Making Mondays feel like Fridays one solution at a time</h1>
                            <p>Foster a culture-driven approach to managing HR, payroll, workforce management, and everything in between with our enterprise human capital management suite.</p>
                            
                            <div className="CTA">
                                
                                  <button>Learn more</button>

                            </div>
                        </div>
                        

                </div>

                  

     
         </div>
        
    </>

}

export default OurWork;